import Alertify from 'alertifyjs'

// Utility functions for showing notifications
export const showNotification = (message, type = 'success') => {
  const alertifyType = type === 'failure' ? 'error' : type
  Alertify.notify(message, alertifyType)
}

export const showSuccess = (message) => showNotification(message, 'success')
export const showError = (message) => showNotification(message, 'error')
export const showWarning = (message) => showNotification(message, 'warning')
export const showInfo = (message) => showNotification(message, 'message')

// Promise-based confirmation dialog using Alertify
export const showConfirm = ({ title, message, confirmText = 'OK', cancelText = 'Cancel' } = {}) => {
  return new Promise((resolve) => {
    Alertify.confirm(
      title,
      message,
      () => resolve(true),
      () => resolve(false)
    ).set('labels', { ok: confirmText, cancel: cancelText })
  })
}

